import { render, staticRenderFns } from "./FixParticipantDeferralRateForm.vue?vue&type=template&id=bfb02f16&"
import script from "./FixParticipantDeferralRateForm.vue?vue&type=script&lang=js&"
export * from "./FixParticipantDeferralRateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports